module.exports = __webpack_public_path__ + "img/buddy_eyes-03.832dbe72.svg";